import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    if (!this.hasFormTarget) return
    
    // Prevent form submission on enter key
    this.formTarget.addEventListener("keypress", (e) => {
      if (e.key === "Enter") {
        e.preventDefault()
      }
    })
  }

  submit() {
    const formData = new FormData(this.element)
    
    // Create a temporary object to collect all values for each parameter
    const paramValues = {}
    
    // Collect all values for each parameter (handles multiple values like checkboxes)
    for (const [key, value] of formData.entries()) {
      if (!paramValues[key]) {
        paramValues[key] = []
      }
      paramValues[key].push(value)
    }
    
    // Create new URLSearchParams with processed values
    const params = new URLSearchParams()
    
    // Process each parameter
    for (const [key, values] of Object.entries(paramValues)) {
      // Filter out empty values or default sort
      const nonEmptyValues = values.filter(value => 
        value !== '' && !(key === 'sort' && value === 'desc')
      )
      
      // Special handling for checkboxes (like filter parameter)
      if (key === 'filter' && values.includes('favorited')) {
        params.append(key, 'favorited')
      } 
      // For other parameters, add all non-empty values
      else if (nonEmptyValues.length > 0) {
        nonEmptyValues.forEach(value => {
          params.append(key, value)
        })
      }
    }

    const queryString = params.toString()
    const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname
    
    history.pushState(null, '', newUrl)
    this.element.requestSubmit()
  }
} 